enum UserRoles {
  Admin = 'administrator',
  Owner = 'owner',
  Staff = 'staff'
};

export default UserRoles;
